import React, { useState, useEffect } from "react";
import { TextField } from "@mui/material";
import axios from "axios";
import { useParams } from "react-router-dom";
import { UNSUBSCRIBE } from "../api/utils";
import cogoToast from "cogo-toast";

export default function Unsubscriber() {
    const { token } = useParams();
    const [message, setMessage] = useState("");
    const [alreadyUnsubscribed, setAlreadyUnsubscribed] = useState(false);

    useEffect(() => {
        document.title = "Unsubscriber - Plural Code Technologies";
    }, []);

    useEffect(() => {
        axios
            .get(`${UNSUBSCRIBE}/verify_unsubscribe/${token}/`)   // ✅ GET call only to verify
            .then(({ data }) => {
                if (data?.success === false) {
                    setAlreadyUnsubscribed(true);
                }
            })
            .catch(() => {
                setAlreadyUnsubscribed(true);
            });
    }, [token]);

    const postUnsubscribe = () => {
        if (message.trim() === "") {
            cogoToast.info("Please enter a reason (optional, but appreciated)");
            return;
        }

        axios
            .post(`${UNSUBSCRIBE}/${token}/confirm`, { reason: message })
            .then(({ data }) => {
                if (data?.success === "ok") {
                    cogoToast.success(data.message || "Successfully unsubscribed");
                    setAlreadyUnsubscribed(true);
                } else {
                    cogoToast.info(data.message || "Unsubscribe failed");
                    if (data.message === "This subscription is already cancelled") {
                        setAlreadyUnsubscribed(true);
                    }
                }
            })
            .catch((err) => {
                cogoToast.error(err.response?.data?.message || "Something went wrong");
                setAlreadyUnsubscribed(true);
            });
    };

    return (
        <div>
            <main className="wrapper">
                <section className="page-hero-sec">
                    <div className="container">
                        <div className="row justify-content-center">
                            <div className="col-lg-12">
                                <h2 className="tc-primary head-font text-center pb-5">
                                    Unsubscribe Our Newsletter
                                </h2>
                            </div>

                            <div className="col-lg-6 col-md-4">
                                {alreadyUnsubscribed ? (
                                    <p className="text-center" style={{ fontSize: 18 }}>
                                        You have already unsubscribed.
                                    </p>
                                ) : (
                                    <>
                                        <TextField
                                            fullWidth
                                            label="Reason for unsubscribing"
                                            value={message}
                                            multiline
                                            rows={6}
                                            style={{ marginTop: 25, background: "#e0e5ef" }}
                                            onChange={(e) => setMessage(e.target.value)}
                                            margin="dense"
                                            inputProps={{ maxLength: 500 }}
                                        />
                                        <button
                                            onClick={postUnsubscribe}
                                            className="link_btn mt-4 mx-auto"
                                            style={{ marginBottom: 50, backgroundColor: "#0a2458", color: "#fff" }}
                                        >
                                            Send
                                        </button>
                                    </>
                                )}
                            </div>
                        </div>
                    </div>
                </section>
            </main>
        </div>
    );
}
